var hexTable = [
    48, 49, 50, 51, 52, 53,
    54, 55, 56, 57, 97, 98,
    99, 100, 101, 102
];
/** Encodes `src` into `src.length * 2` bytes. */
function encode(src) {
    var dst = new Uint8Array(src.length * 2);
    for (var i = 0; i < dst.length; i++) {
        var v = src[i];
        dst[i * 2] = hexTable[v >> 4];
        dst[i * 2 + 1] = hexTable[v & 0x0f];
    }
    return dst;
}

/*
 * Copyright 2017 Sam Thorogood. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy of
 * the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */
/**
 * @fileoverview Polyfill for TextEncoder and TextDecoder.
 *
 * You probably want `text.min.js`, and not this file directly.
 */
// used for FastTextDecoder
var validUtfLabels = ['utf-8', 'utf8', 'unicode-1-1-utf-8'];
/**
 * @constructor
 */
function FastTextEncoder() {
    // This does not accept an encoding, and always uses UTF-8:
    //   https://www.w3.org/TR/encoding/#dom-textencoder
}
Object.defineProperty(FastTextEncoder.prototype, 'encoding', { value: 'utf-8' });
/**
 * @param {string} string
 * @param {{stream: boolean}=} options
 * @return {!Uint8Array}
 */
FastTextEncoder.prototype.encode = function (string, options) {
    if (options === void 0) { options = { stream: false }; }
    if (options.stream) {
        throw new Error('Failed to encode: the \'stream\' option is unsupported.');
    }
    var pos = 0;
    var len = string.length;
    var at = 0; // output position
    var tlen = Math.max(32, len + (len >>> 1) + 7); // 1.5x size
    var target = new Uint8Array((tlen >>> 3) << 3); // ... but at 8 byte offset
    while (pos < len) {
        var value = string.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff) {
            // high surrogate
            if (pos < len) {
                var extra = string.charCodeAt(pos);
                if ((extra & 0xfc00) === 0xdc00) {
                    ++pos;
                    value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                }
            }
            if (value >= 0xd800 && value <= 0xdbff) {
                continue; // drop lone surrogate
            }
        }
        // expand the buffer if we couldn't write 4 bytes
        if (at + 4 > target.length) {
            tlen += 8; // minimum extra
            tlen *= (1.0 + (pos / string.length) * 2); // take 2x the remaining
            tlen = (tlen >>> 3) << 3; // 8 byte offset
            var update = new Uint8Array(tlen);
            update.set(target);
            target = update;
        }
        if ((value & 0xffffff80) === 0) { // 1-byte
            target[at++] = value; // ASCII
            continue;
        }
        else if ((value & 0xfffff800) === 0) { // 2-byte
            target[at++] = ((value >>> 6) & 0x1f) | 0xc0;
        }
        else if ((value & 0xffff0000) === 0) { // 3-byte
            target[at++] = ((value >>> 12) & 0x0f) | 0xe0;
            target[at++] = ((value >>> 6) & 0x3f) | 0x80;
        }
        else if ((value & 0xffe00000) === 0) { // 4-byte
            target[at++] = ((value >>> 18) & 0x07) | 0xf0;
            target[at++] = ((value >>> 12) & 0x3f) | 0x80;
            target[at++] = ((value >>> 6) & 0x3f) | 0x80;
        }
        else {
            continue; // out of range
        }
        target[at++] = (value & 0x3f) | 0x80;
    }
    // Use subarray if slice isn't supported (IE11). This will use more memory
    // because the original array still exists.
    return target.slice ? target.slice(0, at) : target.subarray(0, at);
};
/**
 * @constructor
 * @param {string=} utfLabel
 * @param {{fatal: boolean}=} options
 */
function FastTextDecoder(utfLabel, options) {
    if (utfLabel === void 0) { utfLabel = 'utf-8'; }
    if (options === void 0) { options = { fatal: false }; }
    if (validUtfLabels.indexOf(utfLabel.toLowerCase()) === -1) {
        throw new RangeError("Failed to construct 'TextDecoder': The encoding label provided ('".concat(utfLabel, "') is invalid."));
    }
    if (options.fatal) {
        throw new Error('Failed to construct \'TextDecoder\': the \'fatal\' option is unsupported.');
    }
}
Object.defineProperty(FastTextDecoder.prototype, 'encoding', { value: 'utf-8' });
Object.defineProperty(FastTextDecoder.prototype, 'fatal', { value: false });
Object.defineProperty(FastTextDecoder.prototype, 'ignoreBOM', { value: false });
/**
 * @param {!Uint8Array} bytes
 * @return {string}
 */
function decodeFallback(bytes) {
    var inputIndex = 0;
    // Create a working buffer for UTF-16 code points, but don't generate one
    // which is too large for small input sizes. UTF-8 to UCS-16 conversion is
    // going to be at most 1:1, if all code points are ASCII. The other extreme
    // is 4-byte UTF-8, which results in two UCS-16 points, but this is still 50%
    // fewer entries in the output.
    var pendingSize = Math.min(256 * 256, bytes.length + 1);
    var pending = new Uint16Array(pendingSize);
    var chunks = [];
    var pendingIndex = 0;
    for (;;) {
        var more = inputIndex < bytes.length;
        // If there's no more data or there'd be no room for two UTF-16 values,
        // create a chunk. This isn't done at the end by simply slicing the data
        // into equal sized chunks as we might hit a surrogate pair.
        if (!more || (pendingIndex >= pendingSize - 1)) {
            // nb. .apply and friends are *really slow*. Low-hanging fruit is to
            // expand this to literally pass pending[0], pending[1], ... etc, but
            // the output code expands pretty fast in this case.
            chunks.push(String.fromCharCode.apply(null, pending.subarray(0, pendingIndex)));
            if (!more) {
                return chunks.join('');
            }
            // Move the buffer forward and create another chunk.
            bytes = bytes.subarray(inputIndex);
            inputIndex = 0;
            pendingIndex = 0;
        }
        // The native TextDecoder will generate "REPLACEMENT CHARACTER" where the
        // input data is invalid. Here, we blindly parse the data even if it's
        // wrong: e.g., if a 3-byte sequence doesn't have two valid continuations.
        var byte1 = bytes[inputIndex++];
        if ((byte1 & 0x80) === 0) { // 1-byte or null
            pending[pendingIndex++] = byte1;
        }
        else if ((byte1 & 0xe0) === 0xc0) { // 2-byte
            var byte2 = bytes[inputIndex++] & 0x3f;
            pending[pendingIndex++] = ((byte1 & 0x1f) << 6) | byte2;
        }
        else if ((byte1 & 0xf0) === 0xe0) { // 3-byte
            var byte2 = bytes[inputIndex++] & 0x3f;
            var byte3 = bytes[inputIndex++] & 0x3f;
            pending[pendingIndex++] = ((byte1 & 0x1f) << 12) | (byte2 << 6) | byte3;
        }
        else if ((byte1 & 0xf8) === 0xf0) { // 4-byte
            var byte2 = bytes[inputIndex++] & 0x3f;
            var byte3 = bytes[inputIndex++] & 0x3f;
            var byte4 = bytes[inputIndex++] & 0x3f;
            // this can be > 0xffff, so possibly generate surrogates
            var codepoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0c) | (byte3 << 0x06) | byte4;
            if (codepoint > 0xffff) {
                // codepoint &= ~0x10000;
                codepoint -= 0x10000;
                pending[pendingIndex++] = (codepoint >>> 10) & 0x3ff | 0xd800;
                codepoint = 0xdc00 | codepoint & 0x3ff;
            }
            pending[pendingIndex++] = codepoint;
        }
        else ;
    }
}
// Decoding a string is pretty slow, but use alternative options where possible.
var decodeImpl = decodeFallback;
/**
 * @param {(!ArrayBuffer|!ArrayBufferView)} buffer
 * @param {{stream: boolean}=} options
 * @return {string}
 */
FastTextDecoder.prototype.decode = function (buffer, options) {
    if (options === void 0) { options = { stream: false }; }
    if (options.stream) {
        throw new Error('Failed to decode: the \'stream\' option is unsupported.');
    }
    var bytes;
    if (buffer instanceof Uint8Array) {
        // Accept Uint8Array instances as-is.
        bytes = buffer;
    }
    else if (buffer.buffer instanceof ArrayBuffer) {
        // Look for ArrayBufferView, which isn't a real type, but basically
        // represents all the valid TypedArray types plus DataView. They all have
        // ".buffer" as an instance of ArrayBuffer.
        bytes = new Uint8Array(buffer.buffer);
    }
    else {
        // The only other valid argument here is that "buffer" is an ArrayBuffer.
        // We also try to convert anything else passed to a Uint8Array, as this
        // catches anything that's array-like. Native code would throw here.
        bytes = new Uint8Array(buffer);
    }
    return decodeImpl(/** @type {!Uint8Array} */ (bytes));
};

// Copyright 2018-2022 the Deno authors. All rights reserved. MIT license.
var _TextEncoder = typeof TextEncoder === 'function' ? TextEncoder : FastTextEncoder;
var _TextDecoder = typeof TextDecoder === 'function' ? TextDecoder : FastTextDecoder;
var TYPE_ERROR_MSG = 'md5: `data` is invalid type';
var BLOCK_SIZE = 64;
/**
 * Md5 hash
 * @public
 */
var Md5Hash = /*#__PURE__*/ (function () {
    function Md5Hash() {
        this._a = 0x67452301;
        this._b = 0xefcdab89;
        this._c = 0x98badcfe;
        this._d = 0x10325476;
        this._block = new Uint8Array(BLOCK_SIZE);
        this._pos = 0;
        this._n0 = 0;
        this._n1 = 0;
    }
    Md5Hash.prototype._addLength = function (len) {
        var n0 = this._n0;
        n0 += len;
        if (n0 > 0xffffffff)
            this._n1 += 1;
        this._n0 = n0 >>> 0;
    };
    Md5Hash.prototype._hash = function (block) {
        var a = this._a;
        var b = this._b;
        var c = this._c;
        var d = this._d;
        var blk = function (i) {
            return block[i] |
                (block[i + 1] << 8) |
                (block[i + 2] << 16) |
                (block[i + 3] << 24);
        };
        var rol32 = function (x, n) { return (x << n) | (x >>> (32 - n)); };
        var x0 = blk(0);
        var x1 = blk(4);
        var x2 = blk(8);
        var x3 = blk(12);
        var x4 = blk(16);
        var x5 = blk(20);
        var x6 = blk(24);
        var x7 = blk(28);
        var x8 = blk(32);
        var x9 = blk(36);
        var xa = blk(40);
        var xb = blk(44);
        var xc = blk(48);
        var xd = blk(52);
        var xe = blk(56);
        var xf = blk(60);
        // round 1
        a = b + rol32((((c ^ d) & b) ^ d) + a + x0 + 0xd76aa478, 7);
        d = a + rol32((((b ^ c) & a) ^ c) + d + x1 + 0xe8c7b756, 12);
        c = d + rol32((((a ^ b) & d) ^ b) + c + x2 + 0x242070db, 17);
        b = c + rol32((((d ^ a) & c) ^ a) + b + x3 + 0xc1bdceee, 22);
        a = b + rol32((((c ^ d) & b) ^ d) + a + x4 + 0xf57c0faf, 7);
        d = a + rol32((((b ^ c) & a) ^ c) + d + x5 + 0x4787c62a, 12);
        c = d + rol32((((a ^ b) & d) ^ b) + c + x6 + 0xa8304613, 17);
        b = c + rol32((((d ^ a) & c) ^ a) + b + x7 + 0xfd469501, 22);
        a = b + rol32((((c ^ d) & b) ^ d) + a + x8 + 0x698098d8, 7);
        d = a + rol32((((b ^ c) & a) ^ c) + d + x9 + 0x8b44f7af, 12);
        c = d + rol32((((a ^ b) & d) ^ b) + c + xa + 0xffff5bb1, 17);
        b = c + rol32((((d ^ a) & c) ^ a) + b + xb + 0x895cd7be, 22);
        a = b + rol32((((c ^ d) & b) ^ d) + a + xc + 0x6b901122, 7);
        d = a + rol32((((b ^ c) & a) ^ c) + d + xd + 0xfd987193, 12);
        c = d + rol32((((a ^ b) & d) ^ b) + c + xe + 0xa679438e, 17);
        b = c + rol32((((d ^ a) & c) ^ a) + b + xf + 0x49b40821, 22);
        // round 2
        a = b + rol32((((b ^ c) & d) ^ c) + a + x1 + 0xf61e2562, 5);
        d = a + rol32((((a ^ b) & c) ^ b) + d + x6 + 0xc040b340, 9);
        c = d + rol32((((d ^ a) & b) ^ a) + c + xb + 0x265e5a51, 14);
        b = c + rol32((((c ^ d) & a) ^ d) + b + x0 + 0xe9b6c7aa, 20);
        a = b + rol32((((b ^ c) & d) ^ c) + a + x5 + 0xd62f105d, 5);
        d = a + rol32((((a ^ b) & c) ^ b) + d + xa + 0x02441453, 9);
        c = d + rol32((((d ^ a) & b) ^ a) + c + xf + 0xd8a1e681, 14);
        b = c + rol32((((c ^ d) & a) ^ d) + b + x4 + 0xe7d3fbc8, 20);
        a = b + rol32((((b ^ c) & d) ^ c) + a + x9 + 0x21e1cde6, 5);
        d = a + rol32((((a ^ b) & c) ^ b) + d + xe + 0xc33707d6, 9);
        c = d + rol32((((d ^ a) & b) ^ a) + c + x3 + 0xf4d50d87, 14);
        b = c + rol32((((c ^ d) & a) ^ d) + b + x8 + 0x455a14ed, 20);
        a = b + rol32((((b ^ c) & d) ^ c) + a + xd + 0xa9e3e905, 5);
        d = a + rol32((((a ^ b) & c) ^ b) + d + x2 + 0xfcefa3f8, 9);
        c = d + rol32((((d ^ a) & b) ^ a) + c + x7 + 0x676f02d9, 14);
        b = c + rol32((((c ^ d) & a) ^ d) + b + xc + 0x8d2a4c8a, 20);
        // round 3
        a = b + rol32((b ^ c ^ d) + a + x5 + 0xfffa3942, 4);
        d = a + rol32((a ^ b ^ c) + d + x8 + 0x8771f681, 11);
        c = d + rol32((d ^ a ^ b) + c + xb + 0x6d9d6122, 16);
        b = c + rol32((c ^ d ^ a) + b + xe + 0xfde5380c, 23);
        a = b + rol32((b ^ c ^ d) + a + x1 + 0xa4beea44, 4);
        d = a + rol32((a ^ b ^ c) + d + x4 + 0x4bdecfa9, 11);
        c = d + rol32((d ^ a ^ b) + c + x7 + 0xf6bb4b60, 16);
        b = c + rol32((c ^ d ^ a) + b + xa + 0xbebfbc70, 23);
        a = b + rol32((b ^ c ^ d) + a + xd + 0x289b7ec6, 4);
        d = a + rol32((a ^ b ^ c) + d + x0 + 0xeaa127fa, 11);
        c = d + rol32((d ^ a ^ b) + c + x3 + 0xd4ef3085, 16);
        b = c + rol32((c ^ d ^ a) + b + x6 + 0x04881d05, 23);
        a = b + rol32((b ^ c ^ d) + a + x9 + 0xd9d4d039, 4);
        d = a + rol32((a ^ b ^ c) + d + xc + 0xe6db99e5, 11);
        c = d + rol32((d ^ a ^ b) + c + xf + 0x1fa27cf8, 16);
        b = c + rol32((c ^ d ^ a) + b + x2 + 0xc4ac5665, 23);
        // round 4
        a = b + rol32((c ^ (b | ~d)) + a + x0 + 0xf4292244, 6);
        d = a + rol32((b ^ (a | ~c)) + d + x7 + 0x432aff97, 10);
        c = d + rol32((a ^ (d | ~b)) + c + xe + 0xab9423a7, 15);
        b = c + rol32((d ^ (c | ~a)) + b + x5 + 0xfc93a039, 21);
        a = b + rol32((c ^ (b | ~d)) + a + xc + 0x655b59c3, 6);
        d = a + rol32((b ^ (a | ~c)) + d + x3 + 0x8f0ccc92, 10);
        c = d + rol32((a ^ (d | ~b)) + c + xa + 0xffeff47d, 15);
        b = c + rol32((d ^ (c | ~a)) + b + x1 + 0x85845dd1, 21);
        a = b + rol32((c ^ (b | ~d)) + a + x8 + 0x6fa87e4f, 6);
        d = a + rol32((b ^ (a | ~c)) + d + xf + 0xfe2ce6e0, 10);
        c = d + rol32((a ^ (d | ~b)) + c + x6 + 0xa3014314, 15);
        b = c + rol32((d ^ (c | ~a)) + b + xd + 0x4e0811a1, 21);
        a = b + rol32((c ^ (b | ~d)) + a + x4 + 0xf7537e82, 6);
        d = a + rol32((b ^ (a | ~c)) + d + xb + 0xbd3af235, 10);
        c = d + rol32((a ^ (d | ~b)) + c + x2 + 0x2ad7d2bb, 15);
        b = c + rol32((d ^ (c | ~a)) + b + x9 + 0xeb86d391, 21);
        this._a = (this._a + a) >>> 0;
        this._b = (this._b + b) >>> 0;
        this._c = (this._c + c) >>> 0;
        this._d = (this._d + d) >>> 0;
    };
    /**
     * Update internal state
     * @param data - data to update, data cannot exceed 2^32 bytes
     */
    Md5Hash.prototype.update = function (data) {
        var msg;
        if (typeof data === 'string') {
            msg = new _TextEncoder().encode(data);
        }
        else if (typeof data === 'object') {
            if (data instanceof ArrayBuffer || ArrayBuffer.isView(data)) {
                msg = new Uint8Array(data);
            }
            else {
                throw new TypeError(TYPE_ERROR_MSG);
            }
        }
        else {
            throw new TypeError(TYPE_ERROR_MSG);
        }
        var pos = this._pos;
        var free = BLOCK_SIZE - pos;
        if (msg.length < free) {
            this._block.set(msg, pos);
            pos += msg.length;
        }
        else {
            // hash first block
            this._block.set(msg.slice(0, free), pos);
            this._hash(this._block);
            // hash as many blocks as possible
            var i = free;
            while (i + BLOCK_SIZE <= msg.length) {
                this._hash(msg.slice(i, i + BLOCK_SIZE));
                i += BLOCK_SIZE;
            }
            // store leftover
            this._block.fill(0).set(msg.slice(i), 0);
            pos = msg.length - i;
        }
        this._pos = pos;
        this._addLength(msg.length);
        return this;
    };
    /** Returns final hash */
    Md5Hash.prototype.digest = function () {
        var padLen = BLOCK_SIZE - this._pos;
        if (padLen < 9)
            padLen += BLOCK_SIZE;
        var pad = new Uint8Array(padLen);
        pad[0] = 0x80;
        var n0 = this._n0 << 3;
        var n1 = (this._n1 << 3) | (this._n0 >>> 29);
        pad[pad.length - 8] = n0 & 0xff;
        pad[pad.length - 7] = (n0 >>> 8) & 0xff;
        pad[pad.length - 6] = (n0 >>> 16) & 0xff;
        pad[pad.length - 5] = (n0 >>> 24) & 0xff;
        pad[pad.length - 4] = n1 & 0xff;
        pad[pad.length - 3] = (n1 >>> 8) & 0xff;
        pad[pad.length - 2] = (n1 >>> 16) & 0xff;
        pad[pad.length - 1] = (n1 >>> 24) & 0xff;
        this.update(pad);
        var hash = new ArrayBuffer(16);
        var hashView = new DataView(hash);
        hashView.setUint32(0, this._a, true);
        hashView.setUint32(4, this._b, true);
        hashView.setUint32(8, this._c, true);
        hashView.setUint32(12, this._d, true);
        return new Uint8Array(hash);
    };
    /**
     * Returns hash as a string of given format
     * @param format - format of output string (hex or base64). Default is hex
     */
    Md5Hash.prototype.toString = function (format) {
        if (format === void 0) { format = 'hex'; }
        var hash = this.digest();
        switch (format) {
            case 'hex':
                return new _TextDecoder().decode(encode(hash));
            default:
                throw new Error('md5: invalid format');
        }
    };
    return Md5Hash;
}());
/**
 * 计算 MD5
 * @param data - 数据
 * @returns MD5
 * @public
 */
function md5(data) {
    var hash = new Md5Hash();
    hash.update(data);
    return hash.toString('hex');
}

export { Md5Hash, md5 };
